import React from 'react';

const CONFIGS = {
  'Ticket Assignment':              { bg: 'bg-purple-600 hover:bg-purple-700',   label: 'Assign Ticket' },
  'Troubleshooting':                { bg: 'bg-amber-500 hover:bg-amber-600',     label: 'Start Troubleshooting' },
  'Fault Confirmation':             { bg: 'bg-amber-500 hover:bg-amber-600',     label: 'Confirm Fault Type' },
  'RMA':                            { bg: 'bg-red-600 hover:bg-red-700',         label: 'Raise RMA' },
  'Replacement':                    { bg: 'bg-pink-600 hover:bg-pink-700',       label: 'Raise Replacement' },
  'Configuration and Installation': { bg: 'bg-amber-500 hover:bg-amber-600',     label: 'Mark In Progress' },
  'Maintenance':                    { bg: 'bg-amber-500 hover:bg-amber-600',     label: 'Complete Maintenance' },
  'Resolved':                       { bg: 'bg-emerald-600 hover:bg-emerald-700', label: 'Mark Resolved' },
  'Closed':                         { bg: 'bg-emerald-600 hover:bg-emerald-700', label: 'Close Ticket' },
  'Recovery':                       { bg: 'bg-brand-500 hover:bg-brand-600',     label: 'Start Recovery' },
};

export default function TransitionButton({ transition, onClick, disabled }) {
  const cfg = CONFIGS[transition] || { bg: 'bg-brand-500 hover:bg-brand-600', label: transition };
  return (
    <button
      onClick={() => onClick(transition)}
      disabled={disabled}
      className={`${cfg.bg} text-white px-5 py-2 rounded-xl text-sm font-semibold shadow-sm hover:shadow-md transition-all duration-150 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      {cfg.label}
    </button>
  );
}
